import * as Dialog from '@radix-ui/react-dialog'

import styled, { css } from 'styled-components';
import { AiFillCloseCircle, AiFillDelete } from "react-icons/ai";
import { FaUsersCog } from "react-icons/fa";
import { GrUserAdmin } from "react-icons/gr";
import { IoIosAddCircleOutline } from "react-icons/io";

export const StyledTrigger = styled(Dialog.Trigger)`

    height: 50px;
    display: flex;
    flex-direction: row;
    gap: 10px;
    margin-bottom: 5px;
    align-items: center;
    text-align: center;
    border-radius: 10px;

    transition: opacity .3s;
    &:hover {
        opacity: .7;
        background-color: #F0E68C;
    }

`;

export const StyledOverlay = styled(Dialog.Overlay)`
    background-color: rgba(0, 0, 0, .15);
    position: fixed; 
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
`;

export const StyledContent = styled(Dialog.Content)`
    
    position: fixed; 
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 500px;
    max-width: fit-content;
    max-height: 85vh;
    padding: 20;
    margin-top: -5vh;
    background-color: white;
    border-radius: 6px;

    border: 3px solid black;

    &:focus {
        outline: none;
    }

`;

export const StyledClose = styled(Dialog.Close)`
    position: absolute; 
    top: 0; 
    right: 0; 
    height: 50px;
    padding: 0.375rem;
    border: none;
    background-color: white;
    cursor: pointer;
`;

export const Header = styled.div`

    /* height: 50px; */

    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-left: 5px;
    border-bottom: 2px solid black;


`;

export const TitleHeader = styled.h1`

    margin-left: 8px;

`;

export const Form = styled.form`
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: left;
    justify-content: space-between;
`;

export const SectionBox = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;

    font-size: 20px;
    font-weight: bold;

    justify-content: space-between;

    padding: 10px 5px 5px 10px;

    margin: 7px 0;

    > input {
        width: 95%;
        border-radius: 7px;
    }
`;

export const ResponseList = styled.ul`

    max-height: 260px;
    overflow-y: auto;
    overflow-x: hidden;

    list-style: none;
    margin: 0;
    padding: 0;

    padding-bottom: 5px;

    justify-content: space-between;

    .li-right {
        display: grid;
        grid-template-columns: 0.5fr 3fr 1fr 1fr;

        .right-li-text-box {
            margin: auto;
            text-align: center;
            padding-left: 10px;
        }

        .right-li-button-container {
            justify-self: center;
            text-align: center;

            padding: 4px;
        }

        .right-li-button {
            height: 28px;
            display: flex;
            flex-direction: row;
            margin: auto;
            justify-self: center;
        }
    }

    .li-left {
        width: 100%;
        display: grid;
        grid-template-columns: 0.5fr 3fr 2fr;

        .left-li-text-box {
            margin: auto;
            text-align: center;
            padding-left: 4px;
        }

        .left-li-button-container {
            height: 28px;
            justify-self: center;
            text-align: center;
            padding: 10px;
        }

        .left-li-button {
            
            display: flex;
            flex-direction: row;
            margin: auto;
            justify-self: center;
        }
    }

`;

export const Content = styled.div`

    display: grid;
    grid-template-columns: 1fr 1fr;

`;

export const RightSide = styled.div``;

export const LeftSide = styled.div`
    border-right: 2px solid black;
`;

export const SendButtonContainer = styled.div`

    width: 100%;
    margin: 10px;

    display: flex;
    justify-content: center;

`;

export const TitleContent = styled.h3``;

export const SendButton = styled.button`
    margin: 4px;
`;

export const AiFillCloseCircleIcon = styled(AiFillCloseCircle)`
    width: 28px;
    height: 28px;
    border-radius: 8px;
`;

export const FaUsersCogIcon = styled(FaUsersCog)`
    width: 20px;
    height: 20px;
    color: black;
`;

export const AdminIcon = styled(GrUserAdmin)`

    width: 28px;
    height: 28px;

    margin: auto;
    padding: 10px;

    border-radius: 3px;

    cursor: pointer;

    &:hover {
        opacity: .7;
        background-color: #d3d3d3;
    }

`;

export const AddIcon = styled(IoIosAddCircleOutline)`

    width: 28px;
    height: 28px;

    margin: auto;
    padding: 10px;

    border-radius: 3px;

    cursor: pointer;

    &:hover {
        opacity: .7;
        background-color: #d3d3d3;
    }
`;

export const AiFillDeleteIcon = styled(AiFillDelete)`

    width: 28px;
    height: 28px;

    margin: auto;
    padding: 10px;

    border-radius: 3px;

    cursor: pointer;

    &:hover {
        opacity: .7;
        background-color: #d3d3d3;
    }

`;